import { API_BASE } from '../../config/api';
import AuthService from '../authService';

/** Standard mutation-failure shape used across trip service methods. */
export function failResult(error) {
  return { success: false, error: error.message };
}

/**
 * Shared request wrapper for the trip service modules. Wraps the repeated
 * fetch + auth headers + AuthService.handleResponse + catch/log pattern.
 *
 * @param {string} path - API path starting with /api/...
 * @param {object} opts
 * @param {string} [opts.method='GET']
 * @param {object} [opts.body] - JSON-serialized when provided
 * @param {string} opts.errorLabel - human label for the console.error ("getting trip")
 * @param {function} [opts.transform] - runs on the parsed response inside the
 *   try block, so a throw during post-processing is caught like a fetch error
 * @param {function} [opts.onError=failResult] - maps the caught error to the
 *   method's failure return value; may rethrow (e.g. throwOnError callers)
 */
export async function apiRequest(path, {
  method = 'GET',
  body,
  errorLabel = 'calling trips API',
  transform,
  onError = failResult
} = {}) {
  try {
    const options = { method, headers: AuthService.getJsonHeaders() };
    if (body !== undefined) {
      options.body = JSON.stringify(body);
    }
    const response = await fetch(`${API_BASE}${path}`, options);
    const data = await AuthService.handleResponse(response);
    return transform ? transform(data) : data;
  } catch (error) {
    console.error(`Error ${errorLabel}:`, error);
    return onError(error);
  }
}
